module.exports = __webpack_public_path__ + "static/media/canadaBay.1c0975cb.png";